import { render, staticRenderFns } from "./DataImportModule.vue?vue&type=template&id=103e9b0a"
import script from "./DataImportModule.vue?vue&type=script&lang=js"
export * from "./DataImportModule.vue?vue&type=script&lang=js"
import style0 from "./DataImportModule.vue?vue&type=style&index=0&id=103e9b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports